import { render } from "./ContactUs.vue?vue&type=template&id=b7f6e266&scoped=true"
const script = {}

import "./ContactUs.vue?vue&type=style&index=0&id=b7f6e266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f6e266"]])

export default __exports__